import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b81d4d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "poster-header" }
const _hoisted_2 = { class: "poster-header-title" }
const _hoisted_3 = { class: "poster-body" }
const _hoisted_4 = { class: "poster-table" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"poster-table-title\" data-v-0b81d4d2><div style=\"width:112px;\" data-v-0b81d4d2>方向</div><div style=\"width:193px;\" data-v-0b81d4d2>股票名称</div><div style=\"width:140px;\" data-v-0b81d4d2>转折点</div><div style=\"width:251px;\" data-v-0b81d4d2>观察信号</div></div>", 1)
const _hoisted_6 = { class: "poster-table-column-item" }
const _hoisted_7 = { class: "poster-footer" }
const _hoisted_8 = { class: "line-top" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "【", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "投资顾问：", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "  执业编号：", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "】", -1))
const _hoisted_13 = { class: "line-bottom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: "generateArea",
    class: "poster-container",
    style: _normalizeStyle(_ctx.dynamicStyles(_ctx.theme))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, _toDisplayString(_ctx.currentData.title), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentData.childList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "poster-table-column",
            key: index
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", {
                style: {"width":"112px"},
                class: _normalizeClass((index + 1)%2==0?'color-grey':'color-white')
              }, _toDisplayString(item.direction), 3),
              _createElementVNode("div", {
                style: {"width":"193px"},
                class: _normalizeClass((index + 2)%2==0?'color-grey':'color-white')
              }, _toDisplayString(item.stock_name), 3),
              _createElementVNode("div", {
                style: {"width":"140px"},
                class: _normalizeClass((index + 3)%2==0?'color-grey':'color-white')
              }, _toDisplayString(item.turning_point), 3),
              _createElementVNode("div", {
                style: {"width":"251px"},
                class: _normalizeClass((index + 4)%2==0?'color-grey':'color-white')
              }, _toDisplayString(item.watch_signal), 3)
            ])
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _hoisted_10,
        _createElementVNode("span", null, _toDisplayString(_ctx.currentData.teacher), 1),
        _hoisted_11,
        _createElementVNode("span", null, _toDisplayString(_ctx.currentData.cert_no), 1),
        _hoisted_12
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("span", null, _toDisplayString(_ctx.currentData.risk), 1)
      ])
    ])
  ], 4))
}